<template>
  <section>
    <!-- Action Tools -->
    <div class="row">
      <div class="col-md-8 custom-tools-host">
        <div class="custom-tools">
          <!-- <button class="btn btn-link" @click="sendMessage">
            <i class="fas fa-envelope"></i>
          </button> -->
          <button
            class="btn btn-link"
            :class="{ 'custom-tool-highlight': isEditing }"
            @click="editInfo"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button
            class="btn btn-link"
            :class="{ 'custom-tool-highlight': isConfig }"
            @click="modifyConfig"
          >
            <i class="fas fa-cog"></i>
          </button>
        </div>
      </div>
      <div class="col-md-4"></div>
    </div>
    <div class="row">
      <!-- Advanced Configuration -->
      <div class="col-md-8" v-if="isConfig">
        <div class="row">
          <div class="col-md-12">
            <span>Phone:</span>
            <span class="ms-2">{{ memberPhoneType }}</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <span>Version:</span>
            <span class="ms-2">{{ memberPhoneVersion }}</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <span>App Version:</span>
            <span class="ms-2">{{ memberAppVersion }}</span>
          </div>
        </div>
        <!-- <div class="row mt-3">
          <div class="col-md-12">
            <button
              class="btn btn-outline-secondary btn-sm"
              @click="removeFromOrg"
            >
              Remove from Organization
            </button>
          </div>
        </div> -->
      </div>
      <!-- Editing Member Data -->
      <div class="col-md-8" v-else-if="isEditing">
        <div class="row">
          <div class="col-md-4">
            <z-input
              v-model="memberHeight"
              label="Height (in)"
              type="Number"
              step="any"
              @keyup="showSave = true"
              @change="showSave = true"
            />
          </div>
          <div class="col-md-4">
            <z-select
              v-model="memberGender"
              :options="genders"
              label="Gender"
              @change="showSave = true"
            />
          </div>
          <div class="col-md-4">
            <z-select
              v-model="memberRole"
              :options="roles"
              label="Role"
              @change="showSave = true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <z-input
              v-model="memberWeight"
              label="Weight (lbs)"
              type="Number"
              step="any"
              @keyup="showSave = true"
              @change="showSave = true"
            />
          </div>
          <div class="col-md-4">
            <z-input
              v-model="memberBirthday"
              label="Birthday"
              type="date"
              @change="showSave = true"
            />
          </div>
          <div class="col-md-4">
            <div class="form-group mt-4">
              <input
                type="checkbox"
                id="isAllowTextMessages"
                v-model="memberAllowTexts"
                class="z-checkbox-small"
                @click="showSave = true"
              />
              <label for="isAllowTextMessages" class="custom-allow"
                >allow text messages?</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <button
              class="btn btn-primary btn-sm"
              :class="{ 'btn-danger': showSave }"
              @click="saveMember"
            >
              <i v-if="isSaving" class="fas fa-spinner fa-spin"></i>
              Save
            </button>
          </div>
          <div class="col-md-10"></div>
        </div>
      </div>
      <!-- Viewing Member Data -->
      <div class="col-md-8" v-else>
        <!-- Member Name -->
        <div class="row">
          <div class="col-md-10">
            <div class="d-flex flex-row">
              <h4>{{ memberName }}</h4>
              <span class="custom-nickname">{{ memberNickname }}</span>
              <star
                :level="memberStarLevel"
                :id="memberId"
                class="custom-star"
                @clicked="starClicked"
              />
            </div>
          </div>
          <div class="col-md-2"></div>
        </div>
        <!-- Height | Gender | Role -->
        <div class="row">
          <div class="col-md-4">
            <span>Height:</span>
            <span class="ms-2">{{ memberHeightDisplay }}</span>
          </div>
          <div class="col-md-4">
            <span>Gender:</span>
            <span class="ms-2">{{ memberGender }}</span>
          </div>
          <div class="col-md-4">
            <span>Role:</span>
            <span class="ms-2">{{ memberRoleDisplay }}</span>
          </div>
        </div>
        <!-- Weight | Birthday | Allow Texts -->
        <div class="row">
          <div class="col-md-4">
            <span>Weight:</span>
            <span class="ms-2">{{ memberWeightDisplay }}</span>
          </div>
          <div class="col-md-4">
            <span>Birthday:</span>
            <span class="ms-2">{{ memberBirthdayDisplay }}</span>
          </div>
          <div class="col-md-4">
            <span>Allow Texts:</span>
            <span class="ms-2">{{ memberAllowTextsDisplay }}</span>
          </div>
        </div>
        <!-- Age | Body Type -->
        <div class="row">
          <div class="col-md-4">
            <span>Age:</span>
            <span class="ms-2">{{ memberAge }}</span>
          </div>
          <div class="col-md-4">
            <span>Body Type:</span>
            <span class="ms-2">{{ memberBodyType }}</span>
          </div>
          <div class="col-md-4"></div>
        </div>
        <!-- Phone -->
        <div class="row">
          <div class="col-md-12">
            <span>Phone #:</span>
            <span class="ms-2">{{ memberPhone }}</span>
          </div>
        </div>
        <!-- Email -->
        <div class="row">
          <div class="col-md-12">
            <span>Email:</span>
            <span class="ms-2">{{ memberEmail }}</span>
          </div>
        </div>
      </div>
      <!-- Member Avatar -->
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-12 custom-avatar">
            <img :src="memberAvatar" />
            <div class="custom-status">
              <span>joined:</span>
              <span>{{ memberJoined }}</span>
              <span
                :class="{
                  'custom-active': memberActive === 'active',
                  'custom-not-active': memberActive !== 'active',
                }"
                >{{ memberActive }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Wall Messages (count) -->
    <!-- <div class="row mt-4">
      <div class="col-md-12 custom-line">
        <button
          type="button"
          class="btn btn-primary position-relative"
          @click="viewWallMessages"
        >
          Coaching Wall
          <span
            v-if="messageCount !== null"
            class="
              position-absolute
              top-0
              start-100
              translate-middle
              badge
              rounded-pill
              bg-danger
            "
          >
            {{ messageCount }}
            <span class="visually-hidden">unread messages</span>
          </span>
        </button>
      </div>
    </div> -->
    <div class="row mt-2">
      <user-notes />
    </div>
    <send-message :show="actionMessage" @close="closeDialogs" />
    <coaching-dialog :show="actionCoaching" @close="closeDialogs" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Star from '../elements/star'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import SendMessage from '../actions/send-message'
import CoachingDialog from '@/Components/Coaching/coaching-dialog'
import UserNotes from './notes/notes'
export default {
  name: 'client-basic',
  components: {
    Star,
    ZInput,
    ZSelect,
    SendMessage,
    CoachingDialog,
    UserNotes,
  },
  data() {
    return {
      isConfig: false,
      isEditing: false,
      genders: [
        {
          name: 'Female',
          value: 'female',
        },
        {
          name: 'Male',
          value: 'male',
        },
        {
          name: 'Other',
          value: 'other',
        },
      ],
      actionMessage: null,
      actionCoaching: null,
      showSave: false,
      isSaving: false,
    }
  },
  mounted() {
    this.isConfig = false
    this.isEditing = false
    this.showSave = false
    this.isSaving = false
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('usercardio', ['member']),
    ...mapGetters('users', ['roles']),
    memberId() {
      let _id = null
      if (this.member) {
        _id = this.member.id
      }
      return _id
    },
    memberName() {
      let _name = ''
      if (this.member) {
        _name = `${this.member.firstName} ${this.member.lastName}`
      }
      return _name
    },
    memberNickname() {
      let _name = ''
      if (this.member) {
        if (this.member.nickName !== '') {
          _name = `"${this.member.nickName}"`
        }
      }
      return _name
    },
    memberStarLevel() {
      let _level = 0
      if (this.member) {
        _level = this.member.starlevel
      }
      return _level
    },
    memberAvatar() {
      let _avatar = ''
      if (this.member) {
        _avatar = this.member.avatar
      }
      return _avatar
    },
    memberJoined() {
      let _joined = ''
      if (this.member) {
        _joined = this.member.joined
      }
      return _joined
    },
    memberActive() {
      let _active = 'not active'
      if (this.member) {
        if (this.member.isactive) {
          _active = 'active'
        }
      }
      return _active
    },
    memberAge() {
      let _age = null
      if (this.member) {
        _age = this.member.age
      }
      return _age
    },
    memberBodyType() {
      let _type = ''
      if (this.member) {
        _type = this.member.bodyType
      }
      return _type
    },
    memberPhone() {
      let _phone = ''
      if (this.member) {
        _phone = this.member.phone
      }
      return _phone
    },
    memberEmail() {
      let _email = ''
      if (this.member) {
        _email = this.member.email
      }
      return _email
    },
    memberBirthdayDisplay() {
      let _date = ''
      if (this.member) {
        _date = this.member.dateOfBirth
      }
      return _date
    },
    memberRoleDisplay() {
      let _role = ''
      if (this.member) {
        let found = this.roles.find(
          (x) => parseInt(x.value) === parseInt(this.member.currentRole)
        )
        if (found) {
          _role = found.name
        }
      }
      return _role
    },
    memberHeightDisplay() {
      let _value = ''
      if (this.member) {
        _value = this.member.viewHeight
      }
      return _value
    },
    memberWeightDisplay() {
      let _value = ''
      if (this.member) {
        _value = this.member.viewWeight
      }
      return _value
    },
    memberPhoneType() {
      let _value = ''
      if (this.member) {
        _value = this.member.phoneType
      }
      return _value
    },
    memberPhoneVersion() {
      let _value = ''
      if (this.member) {
        _value = this.member.phoneVersion
      }
      return _value
    },
    memberAppVersion() {
      let _value = ''
      if (this.member) {
        _value = this.member.appVersion
      }
      return _value
    },
    memberAllowTextsDisplay() {
      let _allow = 'No'
      if (this.member) {
        _allow = this.member.allowTextMessages
      }
      return _allow
    },
    memberHeight: {
      get() {
        let _height = null
        if (this.member) {
          _height = this.member.height
        }
        return _height
      },
      set(value) {
        this.setMemberData({
          name: 'height',
          value: value,
        })
      },
    },
    memberWeight: {
      get() {
        let _weight = null
        if (this.member) {
          _weight = this.member.weight
        }
        return _weight
      },
      set(value) {
        this.setMemberData({
          name: 'weight',
          value: value,
        })
      },
    },
    memberGender: {
      get() {
        let _gender = null
        if (this.member) {
          _gender = this.member.gender.toLowerCase()
        }
        return _gender
      },
      set(value) {
        this.setMemberData({
          name: 'gender',
          value: value,
        })
      },
    },
    memberBirthday: {
      get() {
        let _birthday = null
        if (this.member) {
          _birthday = moment(this.member.dateOfBirth, 'MM-DD-YYYY').format(
            'YYYY-MM-DD'
          )
        }
        return _birthday
      },
      set(value) {
        this.setMemberData({
          name: 'birthday',
          value: value,
        })
      },
    },
    memberRole: {
      get() {
        let _role = null
        if (this.member) {
          _role = this.member.currentRole
        }
        return _role
      },
      set(value) {
        this.setMemberData({
          name: 'role',
          value: value,
        })
      },
    },
    memberAllowTexts: {
      get() {
        let _allow = false
        if (this.member) {
          if (this.member.allowTextMessages === 'Yes') {
            _allow = true
          }
        }
        return _allow
      },
      set(value) {
        this.setMemberData({
          name: 'allowTexts',
          value: value ? 'Yes' : 'No',
        })
      },
    },
    messageCount() {
      let _data = null
      if (this.member) {
        if (this.member.unread) {
          let count = parseInt(this.member.unread[0].unread_messages)
          if (count > 0) {
            if (count > 99) {
              _data = '99+'
            } else {
              _data = count
            }
          }
        }
      }
      return _data
    },
  },
  methods: {
    ...mapActions('users', ['saveBioInfo']),
    ...mapActions('coaching', [
      'getWallMessages',
      'resetWallMessages',
      'resetWallMessage',
    ]),
    ...mapActions('usercardio', [
      'getMember',
      'setMemberData',
      'setStarLevel',
      'setMemberForEmail',
    ]),
    closeDialogs() {
      this.actionMessage = null
      this.actionCoaching = null
    },
    refreshData() {},
    async starClicked(data) {
      await this.setStarLevel(data)
    },
    sendMessage() {
      let data = {
        data: [
          {
            user_id: this.memberId,
            FirstName: this.member.firstName,
            LastName: this.member.lastName,
          },
        ],
      }
      this.setMemberForEmail(data)
      data = {
        orgid: null,
        id: this.memberId,
        type: 'notification',
      }
      this.actionMessage = data
    },
    editInfo() {
      this.isConfig = false
      this.isEditing = !this.isEditing
    },
    modifyConfig() {
      this.isEditing = false
      this.isConfig = !this.isConfig
    },
    async saveMember() {
      this.showSave = false
      this.isSaving = true
      let data = {
        id: this.member.id,
        Role: this.member.currentRole,
        DateOfBirth: this.member.dateOfBirth,
        Gender: this.member.gender,
        Height: this.member.height,
        Weight: this.member.weight,
        IsAllowTextMessages:
          this.member.allowTextMessages === 'Yes' ? true : false,
      }
      await this.saveBioInfo(data)
      this.isSaving = false
      this.isEditing = false
      this.$emit('changed')
    },
    removeFromOrg() {},
    async viewWallMessages() {
      this.resetWallMessages()
      let data = {
        id: this.memberId,
        orgId: this.examineOrganization.id,
      }
      this.resetWallMessage(data)
      await this.getWallMessages(data)
      data = {
        id: this.member.id,
        user_id: this.member.id,
        FirstName: this.member.firstName,
        LastName: this.member.lastName,
        NickName: this.member.nickName,
        Avatar: this.member.avatar,
        memberids: null,
      }
      this.actionCoaching = data
      this.$emit('changed')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-nickname {
  position: relative;
  margin-left: 10px;
  top: 4px;
  font-style: italic;
}
.custom-star {
  position: relative;
  margin-left: 5px;
  top: -15px;
}
.custom-tools-host {
  position: relative;
}
.custom-tools {
  position: absolute;
  right: 0;
  top: -15px;
  button {
    box-shadow: none !important;
    padding: 0.275rem 0.5rem;
    // padding: 10px;
  }
}
.custom-tool-highlight {
  border: 1px solid gray;
}
.custom-avatar {
  text-align: center;
  img {
    width: 200px;
  }
}
.custom-status {
  span {
    margin-right: 5px;
  }
}
.custom-active {
  color: green;
  font-weight: 500;
}
.custom-not-active {
  color: red;
  font-weight: 500;
}
.custom-allow {
  margin-left: 5px;
}
.custom-line {
  padding-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
}
</style>
